import React from "react";

export default function Contact(){
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-2xl p-5 bg-white rounded-3xl border shadow-md lg:max-w-4xl lg:p-10 lg:m-2">
      <form className=" flex flex-col" action={`https://formsubmit.co/estherwanjiqu@gmail.com`} method="POST">
        <div className="container flex flex-col">

          <label htmlFor="name" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-2xl">
            <span className="text-md">Name</span>            
          </label>
          <input
              type="text"
              className="max-w-full min-w-fit bg-blue-50 rounded-2xl  h-12"
              name="name"
              id="name"
              required
              placeholder="Enter your name"
            />

          <label htmlFor="email" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-2xl">
            <span className="text-md">Email</span>            
          </label>
          <input
              type="email"
              className="max-w-full min-w-fit bg-blue-50 rounded-2xl  h-12"
              name="email"
              id="email"
              required
              placeholder="Enter your email"
            />


          <label htmlFor="subject" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-2xl">
            <span className="text-md">Subject</span>            
          </label>    
          <input
              type="text"
              className="max-w-full min-w-fit bg-blue-50 rounded-2xl  h-12"
              name="subject"
              id="subject"
              required
              placeholder="Type your subject"
            />

        </div>
       
        <label htmlFor="message" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-2xl">
          <span className="text-md">Message</span>         
        </label>
        <textarea
            className="max-w-full min-w-fit bg-blue-50 rounded-2xl  h-12"
            id="message"
            rows="8"
            placeholder="Type your message..."
            required
            name="message"
          />

        <div>
          <button className=" bg-blue-500 flex w-full mt-4 mb-4 rounded-lg h-12 items-center text-center" type="submit">Submit</button>
        </div>
      </form>
      </div>
  </div>
  );
}